module.exports = __webpack_public_path__ + "static/media/Ubuntu-Medium.8e22c2a6.ttf";